'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice(server, operationalPractices, nonOperationalPractices) {
  this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_server = null;
  this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_operationalPractices = null;
  this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_nonOperationalPractices = null;
  this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_server = server;
  this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_operationalPractices = operationalPractices;
  this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_nonOperationalPractices = nonOperationalPractices;
}
export { $c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice as $c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice };
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype.constructor = $c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice;
/** @constructor */
function $h_Lapp_data_OperationalAppRegisteredUser$GeneralPractice() {
}
export { $h_Lapp_data_OperationalAppRegisteredUser$GeneralPractice as $h_Lapp_data_OperationalAppRegisteredUser$GeneralPractice };
$h_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype = $c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype;
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-733039064), true);
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice)) {
    var x = this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_server;
    var x$2 = x$0.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_server;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$1 = this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_operationalPractices;
      var y = x$0.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_operationalPractices;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_nonOperationalPractices;
      var x$4 = x$0.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_nonOperationalPractices;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype.productArity__I = (function() {
  return 3;
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype.productPrefix__T = (function() {
  return "GeneralPractice";
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_server;
      break;
    }
    case 1: {
      return this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_operationalPractices;
      break;
    }
    case 2: {
      return this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_nonOperationalPractices;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "server";
      break;
    }
    case 1: {
      return "operationalPractices";
      break;
    }
    case 2: {
      return "nonOperationalPractices";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype.outOfOffice__Ljava_time_LocalDate__O = (function(now) {
  var target = this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_operationalPractices;
  var tc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyMapInstances$$anon$1();
  var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => {
    var this$4 = _$1.Lapp_data_GeneralPracticeInvolvement__f_outOfOffice;
    if (this$4.isEmpty__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$4.get__O();
      return x0.validated__Ljava_time_LocalDate__s_Option(now);
    }
  }));
  return this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice.prototype.server__Lapp_data_AppRegisteredUser = (function() {
  return this.Lapp_data_OperationalAppRegisteredUser$GeneralPractice__f_server;
});
function $isArrayOf_Lapp_data_OperationalAppRegisteredUser$GeneralPractice(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_OperationalAppRegisteredUser$GeneralPractice)));
}
export { $isArrayOf_Lapp_data_OperationalAppRegisteredUser$GeneralPractice as $isArrayOf_Lapp_data_OperationalAppRegisteredUser$GeneralPractice };
var $d_Lapp_data_OperationalAppRegisteredUser$GeneralPractice = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice, "app.data.OperationalAppRegisteredUser$GeneralPractice", ({
  Lapp_data_OperationalAppRegisteredUser$GeneralPractice: 1,
  Lapp_data_OperationalAppRegisteredUser: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_OperationalAppRegisteredUser$GeneralPractice as $d_Lapp_data_OperationalAppRegisteredUser$GeneralPractice };
//# sourceMappingURL=app.data.-Operational-App-Registered-User$-General-Practice.js.map
